export default "__VITE_ASSET__16a9a3b1__"